import '/src/scss/styles.scss';
import jQuery from 'jquery';
( window as any ).$ = ( window as any ).jQuery = jQuery;
import 'slick-carousel';
import SmoothScroll from 'smooth-scroll';
import { createApp } from 'vue';
import { HeaderController } from './controllers/header.controller';
import { NavController } from './controllers/nav.controller';
import { initServiceSlider } from './controllers/service-slider.controller';
import NotfallOverlay from './components/NotfallOverlay.vue';
import GallerySlider from './components/GallerySlider.vue';
// ----------------------------------------------------------------
// globals

let scroll: SmoothScroll;
const app: { [ key: string ]: any; } = {
  header: new HeaderController(),
  nav: new NavController()
};
( window as any ).app = app;

// ----------------------------------------------------------------
// event handlers

function onDocumentReady() {
  // IE11 min-height fix on .grid-css
  const homeIntroBox = $( '#page-home > main > .home-intro.grid-css' );
  if ( homeIntroBox ) {
    const boxHeight = homeIntroBox.height() as number;
    const wh = window.innerHeight;
    if ( boxHeight < wh ) {
      homeIntroBox.height( wh );
    }
  }

  initServiceSlider();
}

function onWindowLoaded() {
  scroll = new SmoothScroll( 'a[href*="#"]', { header: 'header' } );

  // check for URL hash and animate scroll, if set
  setTimeout(
    () => {
      scrollToHashIfSet();
    },
    300
  );
}

// ----------------------------------------------------------------
// register event handlers

$( onDocumentReady );
$( window ).on( 'load', onWindowLoaded );

// ----------------------------------------------------------------
// other crazy stuff

function scrollToHashIfSet(): void {
  let hash = window.location.hash;
  if ( typeof hash === 'string' && hash.length > 1 ) {
    hash = hash.substr( 1 );
    const targetEl = document.getElementById( hash );
    if ( targetEl && 'offsetTop' in targetEl ) {
      // https://www.npmjs.com/package/smooth-scroll#animatescroll
      scroll.cancelScroll();
      scroll.animateScroll( targetEl );
    }
  }
}

// ----------------------------------------------------------------
// Vue app

const vueApp = createApp( {
  components: {
    NotfallOverlay,
    GallerySlider,
  },
} );

vueApp.mount( '#app' );
